/**
 * @flow
 */
import React, { Component } from 'react';
import Header from './Layout/Header';
import Footer from './Layout/Footer';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Settings from './Store/Settings';
import { Row, Col } from 'reactstrap';
import { translate  } from 'react-i18next';
import momentLocalizer from 'react-widgets-moment';
import langStore from '../lang';
import moment from 'moment-timezone';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import AbstractBookingRequest from "./Store/Booking/AbstractBookingRequest";

@observer
export class Main extends React.Component<any> {
  @observable loading: boolean = true;

  componentDidMount() {
    if (window.location.pathname !== '/') {
      let promoCode = window.location.pathname.substring(1);
      if (promoCode.indexOf('/') !== -1) {
        promoCode = promoCode.substring(0, promoCode.indexOf('/'));
      }

      if (promoCode && localStorage) {
        localStorage.setItem(AbstractBookingRequest.getPromoCodeStorageKey(), promoCode)
      }
    }

    this.loadSettings();
  }

  async loadSettings() {
    try {
      await Settings.load();

      if (Settings.settings.get('ampm')) {
        moment.locale('en-US');
      } else {
        moment.locale(langStore.i18n.language === 'en' ? 'en-GB' : langStore.i18n.language);
      }
      console.log(Settings.settings.get('timezone'));

      if (Settings.settings.get('timezone')) {
        moment.tz.setDefault(Settings.settings.get('timezone'));
      }

      momentLocalizer();

    } finally {
      this.loading = false;
    }
  }

  handleLangChanged = (lang: string) => {
    window.location.reload();
  };

  render() {
    const { t } = this.props;

    if (this.loading) {
      return (
        <div className="loading-container">
          <div className="loading-text">{t('Die Buchungsplattform wird geladen')}</div>
        </div>
      );
    }

    return (
      <div style={{ overflowX: 'hidden' }}>
        <Header onLangChanged={this.handleLangChanged} />
        <Row style={{ paddingBottom: 100 }}>
          <Col>{this.props.children}</Col>
        </Row>
        <Footer />
      </div>
    );
  }
}

export default translate ()(Main);



// WEBPACK FOOTER //
// ./src/App/Main.js